// import React, { useState } from "react";

// import ExportSuccessPopup from "./ExportSuccessPopup";

// const ExportModalPopup = ({ isOpen, onClose }) => {
//     const [showSuccess, setShowSuccess] = useState(false)
// if (!isOpen && !showSuccess) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white w-[40%] rounded-lg p-6 shadow-xl relative max-h-[80vh] overflow-y-auto">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-xl font-normal">Export Data</h2>
//           <button onClick={onClose} className="text-2xl text-gray-600">×</button>
//         </div>

//         {/* File Type Dropdown */}
//         <div className="mb-4">
//           <label className="block mb-1 text-sm font-normal ">File Type</label>
//           <select className="w-full border px-3 py-2 rounded-md focus: outline-none border-gray-400">
//             <option>Select file type</option>
//             <option>Excel</option>
//             <option>CSV</option>
//           </select>
//         </div>

//         {/* Export Type Dropdown */}
//         <div className="mb-4">
//           <label className="block mb-1 text-sm font-normal">Export Type</label>
//           <select className="w-full border px-3 py-2 mt-4  rounded-md focus: outline-none  border-gray-400">
//             <option>All Records</option>
//             <option>Filtered Records</option>
//             <option>Blank Template</option>
//           </select>
//         </div>

//         {/* Search Input */}
//         <input
//           type="text"
//           placeholder="Search"
//           className=" border border-gray-400 px-3 py-2 ml-10 mt-5 rounded-md mb-4 focus: outline-none w-[90%]"
//         />

//         {/* Action Buttons */}
//         <div className="flex gap-2 mb-4">
//           <button className="bg-gray-200 px-4 py-2 rounded-md">Select All</button>
//           <button className="bg-gray-200 px-4 py-2 rounded-md">Select Mandatory</button>
//           <button className="bg-gray-200 px-4 py-2 rounded-md">Unselect All</button>
//         </div>

//         {/* Checkbox List */}
//         <div>
//           <h4 className="text-md font-semibold underline mb-2">Basic Details</h4>
//           <div className="grid grid-cols-2 gap-2 text-sm">
//             {[
//               "Company ID",
//               "Company Name",
//               "Company Website URL",
//               "Nature of Business",
//               "Primary Email ID",
//               "Additional Email ID",
//               "Primary Contact Number",
//               "Additional Contact Number ( separated by ; , )",
//               "Company LinkedIn URL"
//             ].map((field, i) => (
//               <label key={i} className="flex items-center gap-2">
//                 <input type="checkbox" />
//                 {field}
//               </label>
//             ))}
//           </div>
//         </div>
//   <div>
//           <h4 className="text-md font-semibold underline mb-2">Geo Details</h4>
//           <div className="grid grid-cols-2 gap-2 text-sm">
//             {[
//               "Country",
//               "State",
//               "City/ District",
//               "Street",
//               "Pin Code",
              
//             ].map((field, i) => (
//               <label key={i} className="flex items-center gap-2">
//                 <input type="checkbox" />
//                 {field}
//               </label>
//             ))}
//           </div>
//         </div>

//          <div>
//           <h4 className="text-md font-semibold underline mb-2">Executives</h4>
//           <div className="grid grid-cols-2 gap-2 text-sm">
//             {[
//               "Name",
//               "Designation",
//               "Oragnisation Hierachy",
//               "Primary Contact Number",
//               "Additrional Contact Number",
//               "Preferred Instant Message 1",
//                "Preferred Instant Message -1ID",
//                 "Preferred Instant Message 2",
//                "Preferred Instant Message -2ID",
//                "Personal Linkedin page"
               
              
//             ].map((field, i) => (
//               <label key={i} className="flex items-center gap-2">
//                 <input type="checkbox" />
//                 {field}
//               </label>
//             ))}
//           </div>
//         </div>

//          <div>
//           <h4 className="text-md font-semibold underline mb-2">Other Business Details</h4>
//           <div className="grid grid-cols-2 gap-2 text-sm">
//             {[
//               "Name",
//               "Designation",
//               "Oragnisation Hierachy",
//               "Primary Contact Number",
//               "Additrional Contact Number",
//               "Preferred Instant Message 1",
//                "Preferred Instant Message -1ID",
//                 "Preferred Instant Message 2",
//                "Preferred Instant Message -2ID",
//                "Personal Linkedin page"
               
              
//             ].map((field, i) => (
//               <label key={i} className="flex items-center gap-2">
//                 <input type="checkbox" />
//                 {field}
//               </label>
//             ))}
//           </div>
//         </div>
//         {/* Export Button */}
//         <div className="mt-6 text-right">
//          <button
//   className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700"
//   onClick={() => {
//     setShowSuccess(true);
//    onClose();
//   }}
// >
//   Export Data
// </button>

//         </div>
//       </div>
//            {showSuccess && <ExportSuccessPopup onClose={() => setShowSuccess(false)} />}
//     </div>
//   );
// };

// export default ExportModalPopup;
import React, { useState } from "react";

import ExportSuccessPopup from "./ExportSuccessPopup";

const ExportModalPopup = ({ isOpen, onClose }) => {

if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      {/* Show Success Popup */}
      
        <div className="bg-white w-[40%] rounded-lg p-6 shadow-xl relative max-h-[80vh] overflow-y-auto">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-normal">Export Data</h2>
            <button
              onClick={onClose}
              className="text-2xl text-gray-600"
            >
              ×
            </button>
          </div>

          {/* Dropdowns and Search */}
          <div className="mb-4">
            <label className="block mb-1 text-sm font-normal">File Type</label>
            <select className="w-full border px-3 py-2 rounded-md border-gray-400">
              <option>Select file type</option>
              <option>Excel</option>
              <option>CSV</option>
            </select>
          </div>

          <div className="mb-4">
            <label className="block mb-1 text-sm font-normal">Export Type</label>
            <select className="w-full border px-3 py-2 mt-4 rounded-md border-gray-400">
              <option>All Records</option>
              <option>Filtered Records</option>
              <option>Blank Template</option>
            </select>
          </div>

          <input
            type="text"
            placeholder="Search"
            className="border border-gray-400 px-3 py-2 ml-10 mt-5 rounded-md mb-4 w-[90%]"
          />

          {/* Select Buttons */}
          <div className="flex gap-2 mb-4">
            <button className="bg-gray-200 px-4 py-2 rounded-md">Select All</button>
            <button className="bg-gray-200 px-4 py-2 rounded-md">Select Mandatory</button>
            <button className="bg-gray-200 px-4 py-2 rounded-md">Unselect All</button>
          </div>

          {/* Example Fields */}
            <div>
          <h4 className="text-md font-semibold underline mb-2">Basic Details</h4>
      <div className="grid grid-cols-2 gap-2 text-sm">
             {[
               "Company ID",
               "Company Name",
               "Company Website URL",
               "Nature of Business",
               "Primary Email ID",
               "Additional Email ID",
               "Primary Contact Number",
               "Additional Contact Number ( separated by ; , )",
               "Company LinkedIn URL"
             ].map((field, i) => (
               <label key={i} className="flex items-center gap-2">
                 <input type="checkbox" />
                 {field}
               </label>
             ))}
           </div>
         </div>
   <div>
           <h4 className="text-md font-semibold underline mb-2">Geo Details</h4>
           <div className="grid grid-cols-2 gap-2 text-sm">
             {[
               "Country",
               "State",
               "City/ District",
               "Street",
               "Pin Code",
              
         ].map((field, i) => (
               <label key={i} className="flex items-center gap-2">
                 <input type="checkbox" />
                 {field}
               </label>
             ))}
           </div>
        </div>

          <div>
         <h4 className="text-md font-semibold underline mb-2">Executives</h4>
           <div className="grid grid-cols-2 gap-2 text-sm">
             {[
               "Name",
               "Designation",
               "Oragnisation Hierachy",
               "Primary Contact Number",
               "Additrional Contact Number",
               "Preferred Instant Message 1",
                "Preferred Instant Message -1ID",
                 "Preferred Instant Message 2",
                "Preferred Instant Message -2ID",
                "Personal Linkedin page"
               
              
             ].map((field, i) => (
               <label key={i} className="flex items-center gap-2">
                 <input type="checkbox" />
                 {field}
               </label>
             ))}
           </div>
         </div>
          <div>
           <h4 className="text-md font-semibold underline mb-2">Other Business Details</h4>
           <div className="grid grid-cols-2 gap-2 text-sm">
             {[
               "Name",
               "Designation",
               "Oragnisation Hierachy",
               "Primary Contact Number",
               "Additrional Contact Number",
               "Preferred Instant Message 1",
                "Preferred Instant Message -1ID",
                 "Preferred Instant Message 2",
                "Preferred Instant Message -2ID",
                "Personal Linkedin page"
               
              
             ].map((field, i) => (
               <label key={i} className="flex items-center gap-2">
                 <input type="checkbox" />
                 {field}
               </label>
             ))}
           </div>
       </div> 

          {/* Export Button */}
          <div className="mt-6 text-right">
           <button
  className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700"
  onClick={() => {
    onClose()
 
  }}
>
  Export Data
</button>

          </div>
        </div>

     
    </div>
  );
};

export default ExportModalPopup;
